/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Properties_UpdatedInputs */

const cs_import_stat_properties_updated = /** @type {(inputs: Import_Stat_Properties_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualizováno: ${i?.count}`)
};

const en_import_stat_properties_updated = /** @type {(inputs: Import_Stat_Properties_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Updated: {count}" |
*
* @param {Import_Stat_Properties_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_properties_updated = /** @type {((inputs: Import_Stat_Properties_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Properties_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_properties_updated(inputs)
	return cs_import_stat_properties_updated(inputs)
});